import { Directive, Input, Renderer2, ElementRef } from '@angular/core';

import { colors, colorsAliases } from './color.definition';
export class BackgroundColorDirective {
private currentStyle: any;
private currentClass: any;
/**
 * @param {?} elementRef
 * @param {?} renderer2
 */
constructor(
private elementRef: ElementRef,
private renderer2: Renderer2
  ) {}

   condition = true;
   prefix: string;
   property: string;
/**
 * @param {?} color
 * @return {?}
 */
set color(color: string) {
    if(color && this.condition) {
      this.reset();
      if(colors[color]) {
        this.renderer2.addClass(this.elementRef.nativeElement, 'bg-color');
        this.currentStyle = {property: this.property, color: colors[color]};
        this.renderer2.setStyle(this.elementRef.nativeElement, this.property, colors[color]);
      } else {
        this.renderer2.removeClass(this.elementRef.nativeElement, 'bg-color');
        if(color.startsWith('#') || color.startsWith('rgb')) {
          this.currentStyle = {property: this.property, color: color};
          this.renderer2.setStyle(this.elementRef.nativeElement, this.property, color);
        } else if(colorsAliases.indexOf(color) !== -1) {
          this.currentClass = `${this.prefix}-${color}`;
          this.renderer2.addClass(this.elementRef.nativeElement, this.currentClass);
        }
      }
    }
  }
/**
 * @return {?}
 */
private reset() {
    if(this.currentStyle) {
      this.renderer2.removeStyle(this.elementRef.nativeElement, this.currentStyle.property, this.currentStyle.color);
    } else if(this.currentClass) {
      this.renderer2.removeClass(this.elementRef.nativeElement, this.currentClass);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mkColor]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'condition': [{ type: Input, args: ['mkColorCondition', ] },],
'prefix': [{ type: Input, args: ['mkColorPrefix', ] },],
'property': [{ type: Input, args: ['mkColorProperty', ] },],
'color': [{ type: Input, args: ['mkColor', ] },],
};
}

function BackgroundColorDirective_tsickle_Closure_declarations() {
/** @type {?} */
BackgroundColorDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BackgroundColorDirective.ctorParameters;
/** @type {?} */
BackgroundColorDirective.propDecorators;
/** @type {?} */
BackgroundColorDirective.prototype.currentStyle;
/** @type {?} */
BackgroundColorDirective.prototype.currentClass;
/** @type {?} */
BackgroundColorDirective.prototype.condition;
/** @type {?} */
BackgroundColorDirective.prototype.prefix;
/** @type {?} */
BackgroundColorDirective.prototype.property;
/** @type {?} */
BackgroundColorDirective.prototype.elementRef;
/** @type {?} */
BackgroundColorDirective.prototype.renderer2;
}

export class ColorDirective {
private currentStyle: any;
private currentClass: any;
/**
 * @param {?} elementRef
 * @param {?} renderer2
 */
constructor(
private elementRef: ElementRef,
private renderer2: Renderer2
  ) {}
/**
 * @param {?} color
 * @return {?}
 */
set color(color: string) {
    if(color) {
      this.reset();
      if(color.startsWith('#') || color.startsWith('rgb')) {
        this.currentStyle = color;
        this.renderer2.setStyle(this.elementRef.nativeElement, 'color', color);
      } else {
        this.currentClass = `text-${color}`;
        this.renderer2.addClass(this.elementRef.nativeElement, this.currentClass);
      }
    }
  }
/**
 * @return {?}
 */
private reset() {
    if(this.currentStyle) {
      this.renderer2.removeStyle(this.elementRef.nativeElement, 'color', this.currentStyle);
    } else if(this.currentClass) {
      this.renderer2.removeClass(this.elementRef.nativeElement, this.currentClass);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mkFontColor]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'color': [{ type: Input, args: ['mkFontColor', ] },],
};
}

function ColorDirective_tsickle_Closure_declarations() {
/** @type {?} */
ColorDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ColorDirective.ctorParameters;
/** @type {?} */
ColorDirective.propDecorators;
/** @type {?} */
ColorDirective.prototype.currentStyle;
/** @type {?} */
ColorDirective.prototype.currentClass;
/** @type {?} */
ColorDirective.prototype.elementRef;
/** @type {?} */
ColorDirective.prototype.renderer2;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
